import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";

import { SERVER_ERROR_MESSAGE } from "../../constants/errors";
import { cockpitService } from "../../services/cockpitService";
import { cockpitActions, formsActions } from "../ducks";

const { loadingRequest } = formsActions;
const { registrarEstimulo } = cockpitActions;

export function* registrarEstimuloCockpit({ payload }) {
    try {
        yield put(loadingRequest(true));
        const data = yield call(cockpitService, payload);
        if (data) {
            yield put(registrarEstimulo(payload));
        }
    } catch (error) {
        toast.error(SERVER_ERROR_MESSAGE);
    } finally {
        yield put(loadingRequest(false));
    }
}
